import { Component, effect, OnInit, ViewChild } from '@angular/core';
import { VITALS_FIELD } from 'src/app/global';
import { PatientDashboardTabComponent } from 'src/app/patients/dashboard-page/dashboard-tab/dashboard-tab.component';
import { Vital } from 'src/app/calvin-emr-shared/models/vitals.model';
import { VitalsFormComponent } from './vitals-form/vitals-form.component';
import { TableModule } from 'primeng/table';
import { PrimeTemplate } from 'primeng/api';
import { ButtonDirective } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { VitalsChartComponent } from './vitals-chart/vitals-chart.component';

type FlushReason = 'manual' | 'tab-switch' | 'route-leave' | 'destroy';

@Component({
  selector: 'app-vitals-tab',
  templateUrl: './vitals-tab.component.html',
  styleUrls: ['./vitals-tab.component.scss'],
  standalone: true,
  imports: [
    VitalsFormComponent,
    TableModule,
    PrimeTemplate,
    ButtonDirective,
    TooltipModule,
    VitalsChartComponent,
  ],
})
export class VitalsTabComponent extends PatientDashboardTabComponent implements OnInit {
  @ViewChild(VitalsFormComponent) vitalsFormComponent?: VitalsFormComponent;
  /**
   * Vitals that can be viewed in the Vitals chart.
   */
  viewableVitals: string[] = [
    'Heart Rate',
    'Oxygen Saturation',
    'Respirations',
    'Temperature',
    'Systolic BP',
    'Diastolic BP',
  ];

  vitals: Vital[] = [];

  constructor() {
    super();
    effect(() => {
      this.vitals = this.patientStore.patient().vitals;
    });
  }

  ngOnInit(): void { }

  public flushPendingVitals(reason: FlushReason): boolean {
    const didFlush = this.vitalsFormComponent?.flushPendingVital(reason) ?? false;
    if (didFlush && reason !== 'manual') {
      // Autosave: silent update
      this.updatePatientField(VITALS_FIELD, this.vitals, { silent: true });
    }
    return didFlush;
  }
  /**
   * @param vital The Vital object to add to the patient's vitals array.
   */
  addVital(vital: Vital) {
    this.vitals.push(vital);
    this.updatePatientField(VITALS_FIELD, this.vitals);
  }

  editVital(vital: Vital) {
    console.log('Edit');
    this.updatePatientField(VITALS_FIELD, this.vitals);
  }

  deleteVital(vital: Vital): void {
    if (this.isAdmin) {
      this.vitals = this.vitals.filter((v) => v != vital);
    } else {
      vital.toggleDelete();
    }
    this.updatePatientField(VITALS_FIELD, this.vitals);
  }

  updatePatientField(field: string, data: any, options?: { silent?: boolean }) {
    this.patientStore.setField({
      field,
      data,
      ...(options?.silent !== undefined ? { silent: options.silent } : {}),
    });
  }
}
